/**
 * DOPP Integration - Applique les prix Regios sur les sections ax-push-products et quick-add popup
 */
(function() {
  'use strict';

  const DEBUG = false;
  const CARD_SELECTOR = '[data-ax-section="pushProducts"] .card-wrapper[data-dopp-product-id]';
  const QUICK_ADD_SELECTOR = '.quick-add-modal__content';

  function log(...args) {
    if (DEBUG) console.log('[DOPP]', ...args);
  }

  // Cache des données produit pour éviter les appels API répétés
  const productCache = new Map();

  function extractCardData(card) {
    return {
      productId: parseInt(card.dataset.doppProductId, 10),
      variantId: parseInt(card.dataset.doppVariantId, 10),
      regularPriceInCents: parseInt(card.dataset.doppPrice, 10),
      collectionIds: (card.dataset.doppCollectionIds || '').split(',').map(id => parseInt(id.trim(), 10)).filter(Boolean),
      tags: (card.dataset.doppTags || '').split('|||').map(t => t.trim()).filter(Boolean)
    };
  }

  function applyPriceToCard(card, result) {
    const { salePrice, regularPrice } = result;
    if (!salePrice || salePrice.amount >= regularPrice.amount) {
      log('Pas de réduction pour:', card.dataset.doppHandle);
      return;
    }

    log('Prix DOPP:', salePrice.formatted, '←', regularPrice.formatted);
    card.dataset.doppApplied = 'true';

    const priceContainer = card.querySelector('.price');
    if (!priceContainer) return;

    priceContainer.classList.add('price--on-sale');
    priceContainer.classList.remove('price--club');

    const saleContainer = priceContainer.querySelector('.price__sale');
    if (saleContainer) {
      const compareEl = saleContainer.querySelector('.price-item--regular');
      const saleEl = saleContainer.querySelector('.price-item--sale');
      if (compareEl) compareEl.textContent = regularPrice.formatted;
      if (saleEl) saleEl.textContent = salePrice.formatted;
      saleContainer.style.display = '';
    }

    const discountEl = priceContainer.querySelector('.price__discount-amount');
    if (discountEl) {
      const savings = regularPrice.amount - salePrice.amount;
      const savingsFormatted = savings % 1 === 0
        ? savings.toFixed(0) + '€'
        : savings.toFixed(2).replace('.', ',') + '€';
      discountEl.textContent = 'Economisez ' + savingsFormatted;
    }
  }

  function applyPriceToQuickAdd(modal, result) {
    const { salePrice, regularPrice } = result;
    if (!salePrice || salePrice.amount >= regularPrice.amount) {
      log('Pas de réduction dans quick-add');
      return;
    }

    log('Prix DOPP quick-add:', salePrice.formatted, '←', regularPrice.formatted);

    const priceContainer = modal.querySelector('.price');
    if (!priceContainer) return;

    priceContainer.classList.add('price--on-sale');

    // Mettre à jour le prix régulier (barré)
    const regularEl = priceContainer.querySelector('.price__regular .price-item--regular');
    if (regularEl) regularEl.textContent = regularPrice.formatted;

    // Mettre à jour le prix sale
    const saleContainer = priceContainer.querySelector('.price__sale');
    if (saleContainer) {
      saleContainer.style.display = '';
      const compareEl = saleContainer.querySelector('.price-item--regular');
      const saleEl = saleContainer.querySelector('.price-item--sale');
      if (compareEl) compareEl.textContent = regularPrice.formatted;
      if (saleEl) saleEl.textContent = salePrice.formatted;
    }

    // Cacher le prix régulier non-barré si le sale est affiché
    const regularContainer = priceContainer.querySelector('.price__regular');
    if (regularContainer && saleContainer) {
      regularContainer.style.display = 'none';
    }

    // Mettre à jour le montant économisé
    const discountEl = priceContainer.querySelector('.price__discount-amount');
    if (discountEl) {
      const savings = regularPrice.amount - salePrice.amount;
      const savingsFormatted = savings % 1 === 0
        ? savings.toFixed(0) + '€'
        : savings.toFixed(2).replace('.', ',') + '€';
      discountEl.textContent = 'Economisez ' + savingsFormatted;
    }
  }

  async function processCard(card, api) {
    if (card.dataset.doppApplied === 'true') return;

    const data = extractCardData(card);
    if (!data.productId || !data.variantId || !data.regularPriceInCents) return;

    try {
      const result = await api.calculateDiscountedPrices(data);
      if (result?.salePrice) applyPriceToCard(card, result);
    } catch (e) {
      console.error('[DOPP] Erreur:', e);
    }
  }

  async function fetchProductData(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    try {
      const response = await fetch(`/products/${handle}.json`);
      const data = await response.json();
      const product = data.product;
      const result = {
        id: product.id,
        handle: product.handle,
        tags: product.tags.split(', '),
        variants: product.variants.map(v => ({
          id: v.id,
          price: Math.round(parseFloat(v.price) * 100)
        }))
      };
      productCache.set(handle, result);
      return result;
    } catch (e) {
      console.error('[DOPP] Erreur fetch produit:', e);
      return null;
    }
  }

  async function processQuickAdd(modal, api) {
    const variantSelects = modal.querySelector('variant-selects');
    if (!variantSelects) return;

    const productUrl = variantSelects.dataset.url;
    if (!productUrl) return;

    const handle = productUrl.replace('/products/', '').split('?')[0];
    const product = await fetchProductData(handle);
    if (!product) return;

    const variantInput = modal.querySelector('input[name="id"]');
    const currentVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
    if (!currentVariantId) return;

    const variant = product.variants.find(v => v.id === currentVariantId);
    if (!variant) return;

    log('Quick-add:', handle, 'variant:', currentVariantId);

    try {
      const result = await api.calculateDiscountedPrices({
        productId: product.id,
        variantId: currentVariantId,
        regularPriceInCents: variant.price,
        tags: product.tags
      });
      if (result?.salePrice) {
        applyPriceToQuickAdd(modal, result);
        modal.dataset.doppApplied = currentVariantId;
      }
    } catch (e) {
      console.error('[DOPP] Erreur quick-add:', e);
    }
  }

  function observeQuickAdd(api) {
    let debounceTimer;
    let priceObserver = null;
    let lastProcessedPrice = null;

    const processModal = async () => {
      const modal = document.querySelector(QUICK_ADD_SELECTOR);
      if (!modal) return;

      const variantInput = modal.querySelector('input[name="id"]');
      const currentVariantId = variantInput?.value;
      if (!currentVariantId) return;

      const priceContainer = modal.querySelector('.price');
      if (!priceContainer) return;

      // Vérifier si le prix affiché est le prix original (pas encore modifié par DOPP)
      const saleEl = priceContainer.querySelector('.price__sale .price-item--sale');
      const currentDisplayedPrice = saleEl?.textContent?.trim();

      // Si c'est le même prix qu'on a déjà traité, ne pas retraiter
      const cacheKey = `${currentVariantId}-${currentDisplayedPrice}`;
      if (modal.dataset.doppProcessed === cacheKey) return;

      log('Processing quick-add, variant:', currentVariantId);
      await processQuickAdd(modal, api);

      // Marquer comme traité avec le variant ET le prix pour éviter les boucles
      modal.dataset.doppProcessed = `${currentVariantId}-${saleEl?.textContent?.trim()}`;
    };

    // Observer les changements dans le popup (prix mis à jour par Shopify)
    const setupPriceObserver = (modal) => {
      if (priceObserver) priceObserver.disconnect();

      const priceContainer = modal.querySelector('.price');
      if (!priceContainer) return;

      priceObserver = new MutationObserver((mutations) => {
        // Ignorer si c'est nous qui avons fait la modification
        const dominated = mutations.some(m =>
          m.type === 'characterData' ||
          (m.type === 'childList' && m.addedNodes.length > 0)
        );
        if (!dominated) return;

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          // Reset pour permettre le retraitement
          delete modal.dataset.doppProcessed;
          processModal();
        }, 100);
      });

      priceObserver.observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    };

    // Observer l'ouverture/fermeture du modal
    const bodyObserver = new MutationObserver(() => {
      const modal = document.querySelector(QUICK_ADD_SELECTOR);
      if (modal && modal.offsetParent !== null) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          setupPriceObserver(modal);
          processModal();
        }, 200);
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });

    // Écouter aussi les changements de variant
    document.addEventListener('change', (e) => {
      const variantSelects = e.target.closest('variant-selects');
      if (!variantSelects) return;

      const modal = document.querySelector(QUICK_ADD_SELECTOR);
      if (!modal) return;

      // Reset et attendre que Shopify mette à jour le prix
      delete modal.dataset.doppProcessed;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(processModal, 300);
    });
  }

  function processAllCards(api) {
    const cards = document.querySelectorAll(CARD_SELECTOR);
    log('Traitement de', cards.length, 'cards');
    cards.forEach(card => processCard(card, api));
  }

  function observeNewCards(api) {
    let timer;
    const observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        document.querySelectorAll(`${CARD_SELECTOR}:not([data-dopp-applied])`)
          .forEach(card => processCard(card, api));
      }, 100);
    });

    document.querySelectorAll('[data-ax-section="pushProducts"]').forEach(section => {
      observer.observe(section, { childList: true, subtree: true });
    });
  }

  // ===========================================
  // Correction des affichages Regios (global)
  // ===========================================

  function parsePrice(text) {
    if (!text) return null;
    const match = text.replace(/\s/g, '').match(/([\d,\.]+)/);
    if (!match) return null;
    return parseFloat(match[1].replace(',', '.'));
  }

  function formatSavings(amount) {
    if (amount % 1 === 0) {
      return amount.toFixed(0) + '€';
    }
    return amount.toFixed(2).replace('.', ',') + '€';
  }

  function fixPriceContainer(priceContainer) {
    if (!priceContainer) return;

    // Récupérer les prix
    const regularEl = priceContainer.querySelector('.price__sale .price-item--regular, .price-item--regular s');
    const saleEl = priceContainer.querySelector('.price-item--sale');
    const discountEl = priceContainer.querySelector('.price__discount-amount');

    if (!regularEl || !saleEl || !discountEl) return;

    const regularPrice = parsePrice(regularEl.textContent);
    const salePrice = parsePrice(saleEl.textContent);

    if (!regularPrice || !salePrice || salePrice >= regularPrice) return;

    const savings = regularPrice - salePrice;
    const expectedText = 'Economisez ' + formatSavings(savings);
    const currentText = discountEl.textContent.trim().replace(/\s+/g, ' ');

    // Créer une clé unique basée sur les prix pour détecter les vrais changements
    const priceKey = `${regularPrice}-${salePrice}`;

    // Ne corriger que si le prix a changé ou si l'économie est incorrecte
    if (priceContainer.dataset.doppPriceKey === priceKey) {
      // Prix identique, juste s'assurer que c'est révélé
      discountEl.style.opacity = '1';
      return;
    }

    // Nouveau prix détecté
    if (!currentText.includes(formatSavings(savings))) {
      log('Correction économisez:', currentText, '→', expectedText);
      discountEl.textContent = expectedText;
    }

    // Révéler l'élément (anti-flicker)
    discountEl.style.opacity = '1';

    priceContainer.dataset.doppPriceKey = priceKey;
  }

  function hideRegiosDescriptions() {
    document.querySelectorAll('.regios-dopp-description').forEach(el => {
      if (el.style.display !== 'none') {
        el.style.display = 'none';
        log('Caché regios-dopp-description');
      }
    });
  }

  /**
   * Corrige tous les badges d'un conteneur en une seule passe :
   * - Transforme "XX% OFF" en "XX%"
   * - Supprime les doublons de pourcentage
   * - Ajoute "Ventes Privées" si nécessaire (uniquement pour badges Regios, pas Liquid natifs)
   * - Marque tous les badges comme prêts à la fin
   */
  function fixBadgeContainer(container) {
    const badges = Array.from(container.querySelectorAll('.badge'));
    const seenPercents = new Set();
    let hasRegiosPercentBadge = false;
    let hasVentesPrivees = false;
    const badgesToRemove = [];

    // Premier passage : analyser et transformer
    badges.forEach(badge => {
      const text = badge.textContent?.trim();

      // Vérifier si c'est "Ventes Privées"
      if (text === 'Ventes Privées') {
        hasVentesPrivees = true;
        return;
      }

      // Transformer "XX% OFF" en "XX%"
      const offMatch = text?.match(/^(\d+%)\s*OFF$/i);
      if (offMatch) {
        badge.textContent = offMatch[1];
        log('Badge simplifié:', text, '→', offMatch[1]);
      }

      // Vérifier si c'est un badge de pourcentage
      const percentMatch = badge.textContent?.trim().match(/^-?(\d+)%$/);
      if (percentMatch) {
        const percent = percentMatch[1] + '%';
        if (seenPercents.has(percent)) {
          // Doublon à supprimer
          badgesToRemove.push(badge);
          log('Badge pourcentage dupliqué marqué pour suppression:', percent);
        } else {
          seenPercents.add(percent);
          // Badge Regios = pas d'id et pas de classe color-scheme
          // Badge Liquid natif = a un id (Badge-xxx) et une classe color-scheme
          const isLiquidBadge = badge.id && badge.className.includes('color-');
          if (!isLiquidBadge) {
            hasRegiosPercentBadge = true;
          }
        }
      }
    });

    // Supprimer les doublons
    badgesToRemove.forEach(badge => badge.remove());

    // Ajouter "Ventes Privées" seulement si on a un badge Regios (pas Liquid natif)
    if (hasRegiosPercentBadge && !hasVentesPrivees) {
      const vpBadge = document.createElement('span');
      vpBadge.className = 'badge';
      vpBadge.textContent = 'Ventes Privées';
      container.insertBefore(vpBadge, container.firstChild);
      log('Badge Ventes Privées ajouté');
    }

    // Marquer tous les badges restants comme prêts (révélation)
    container.querySelectorAll('.badge').forEach(badge => {
      badge.dataset.doppReady = 'true';
    });
  }

  function fixAllRegiosDisplays() {
    // Corriger tous les conteneurs de badges en une passe
    document.querySelectorAll('.card__badge').forEach(fixBadgeContainer);

    // Corriger les montants "Economisez"
    document.querySelectorAll('.price').forEach(fixPriceContainer);

    // Cacher "ventes privées" (texte sous le prix)
    hideRegiosDescriptions();

    // Révéler tous les éléments restants (fallback)
    revealRemainingElements();
  }

  function revealRemainingElements() {
    // Révéler les "Economisez" non traités
    document.querySelectorAll('.price__discount-amount').forEach(el => {
      el.style.opacity = '1';
    });
    // Révéler les badges non traités (fallback)
    document.querySelectorAll('.badge:not([data-dopp-ready])').forEach(badge => {
      badge.dataset.doppReady = 'true';
    });
  }

  function observeRegiosFixes() {
    let debounceTimer;
    let isProcessing = false;

    const processChanges = () => {
      if (isProcessing) return;
      isProcessing = true;

      // Utiliser requestAnimationFrame pour regrouper les corrections visuelles
      requestAnimationFrame(() => {
        fixAllRegiosDisplays();
        // Petit délai avant de permettre de nouveaux traitements
        setTimeout(() => {
          isProcessing = false;
        }, 100);
      });
    };

    const observer = new MutationObserver((mutations) => {
      // Ignorer les mutations causées par nos propres modifications (data-dopp-*)
      const isOurMutation = mutations.every(m =>
        m.type === 'attributes' && m.attributeName?.startsWith('data-dopp')
      );
      if (isOurMutation) return;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(processChanges, 150);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  function init() {
    const hasPushProducts = !!document.querySelector('[data-ax-section="pushProducts"]');

    log('Init sur', location.pathname, hasPushProducts ? '(avec pushProducts)' : '(popup only)');

    let done = false;
    const start = () => {
      if (done) return;
      done = true;
      const api = window.RegiosDOPP.api.v0;
      log('API prête');

      // Cards pushProducts seulement si la section existe
      if (hasPushProducts) {
        processAllCards(api);
        observeNewCards(api);
      }

      // Quick-add popup sur toutes les pages
      observeQuickAdd(api);

      // Corrections globales des affichages Regios (économisez + ventes privées)
      fixAllRegiosDisplays();
      observeRegiosFixes();
    };

    if (window.RegiosDOPP?.api?.v0) {
      start();
    } else {
      document.addEventListener('regios-dopp:api-initialized', start);
      const poll = setInterval(() => {
        if (window.RegiosDOPP?.api?.v0) { clearInterval(poll); start(); }
      }, 200);
      setTimeout(() => clearInterval(poll), 10000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
